import React, { useMemo } from "react";

// Lightweight golden "diya spark / firefly" effect — CSS driven, no heavy WebGL.
// Renders a set of floating gold particles rising like embers.
const Sparkles = ({ count = 26, className = "" }) => {
  const sparks = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        bottom: Math.random() * 30,
        size: 1 + Math.random() * 3,
        delay: Math.random() * 8,
        duration: 6 + Math.random() * 8,
        opacity: 0.3 + Math.random() * 0.6,
      })),
    [count]
  );

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
      data-testid="sparkles-layer"
    >
      {sparks.map((s) => (
        <span
          key={s.id}
          style={{
            position: "absolute",
            left: `${s.left}%`,
            bottom: `${s.bottom}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            borderRadius: "9999px",
            background:
              "radial-gradient(circle, rgba(255,214,120,1) 0%, rgba(212,175,55,0.6) 45%, rgba(212,175,55,0) 70%)",
            boxShadow: "0 0 6px rgba(255,190,90,0.8)",
            opacity: s.opacity,
            animation: `float-spark ${s.duration}s ease-in-out ${s.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};

export default Sparkles;
